<template>
  <article class="course-detail">
    <template v-if="data">
      <breadcrumb :data="breadcrumbData" v-if="!isMobile"></breadcrumb>

      <h2 class="course-detail-title ellipsis" v-if="isSubject">
        {{ data.subject_desc }}
      </h2>
      <h3 class="course-detail-subtitle ellipsis">
        {{ data.post_title }}
        <lr-link
          v-if="isMobile && data.parent_id"
          :to="`/course/detail/id/${data.parent_id}`"
        >
          电脑上如何操作？
        </lr-link>
        <lr-link
          v-if="!isMobile && data.mobile_id"
          :to="`/course/detail/id/${data.mobile_id}`"
        >
          手机上如何操作？
        </lr-link>
      </h3>
      <p class="course-detail-info">
        <span>发布时间：{{ data.published_time | YYYYMMDD }}</span>
        <span>难度：{{ difficultyMap[data.difficulty] }}</span>
      </p>

      <div class="course-detail-main-wrapper">
        <div class="course-detail-main">
          <div
            class="course-detail-video"
            v-show="data && data.post_video && data.post_video.url"
          >
            <div class="course-detail-video-wrapper">
              <pc-player
                ref="PCPlayer"
                class="course-detail-video-player"
                :data="data"
                :isFullScreen="status.fullScreen"
                :playIconShow="status.playIconShow"
                :pauseIconShow="status.pauseIconShow"
                :notplayHelperShow="
                  status.notplayHelperShow && !status.playerEnd
                "
                :usefulTipShow.sync="status.videoPlayingUsefulTipShow"
                :mutedNoticeShow.sync="status.videoMutedNoticeShow"
                :reportUsefulTipShow="
                  (params) => this.reportUsefulTipShow(params)
                "
                :reportUsefulTipClick="
                  (params) => this.reportUsefulTipClick(params)
                "
                :reportClick="(params) => this.reportClick(params)"
                :reportShow="(params) => this.reportShow(params)"
                @play-click="handlePlayClick"
                @pause-click="handlePauseClick"
                @ready="handleVideoReady"
                @useful-click="handleUsefulClick"
                @mouseenter.native="
                  debounceVideoMouseEnter(
                    $event,
                    $refs['PCPlayer'] && $refs['PCPlayer'].$el
                  )
                "
                @mousemove.native="throttlingVideoMouseMove"
                @mouseout.native="
                  debounceVideoMouseOut(
                    $event,
                    $refs['PCPlayer'] && $refs['PCPlayer'].$el
                  )
                "
                @mousedown.native.capture="handleVideoClick"
                v-if="!isMobile"
                :videoWrapper="videoWrapper"
              ></pc-player>

              <mobile-player
                class="course-detail-video-player"
                :data="data"
                :playIconShow="status.playIconShow"
                :pauseIconShow="status.pauseIconShow"
                @play-click="handlePlayClick"
                @pause-click="handlePauseClick"
                @ready="handleVideoReady"
                v-else
              ></mobile-player>

              <join-learning-popup
                v-if="joinLearningPopupShow"
                @close="handleCloseJoinLearningPopup"
                @success="joinUserLearning"
              />
              <wx-qrcode-popup
                v-if="wxQRCodePopupShow"
                @close="handleCloseWxQRCodePopup"
              />

              <guide-to-phone
                class="course-detail-video-pause-popup"
                v-show="pauseGuidePopupShow"
                ref="guideToPhone"
                :isFullScreen="status.fullScreen"
                :url="`${data.wechat_link}?chan=pc_web_video`"
                :close="() => (pauseGuidePopupShow = false)"
                show-figure
              />

              <video-end
                ref="videoEnd"
                class="course-detail-video-end"
                :isCanPlayNextCourse="isCanPlayNextCourse"
                :usefulTipShow="status.videoEndUsefulTipShow"
                :background="data.thumbnail"
                :player="player"
                :cate="data.top_cate"
                :id="id"
                :nextCourseUrl="nextCourseUrl"
                :isSubject="isSubject"
                :isFullScreen="status.fullScreen"
                :reportClick="
                  (params) => this.reportClick({ area: 'end', ...params })
                "
                :reportShow="
                  (params) => this.reportShow({ ...params })
                "
                @useful-click="handleUsefulClick"
                @mouseenter.native="
                  debounceVideoMouseEnter(
                    $event,
                    $refs['videoEnd'] && $refs['videoEnd'].$el
                  )
                "
                @mousemove.native="throttlingVideoMouseMove"
                @mouseout.native="
                  debounceVideoMouseOut(
                    $event,
                    $refs['videoEnd'] && $refs['videoEnd'].$el
                  )
                "
              ></video-end>
            </div>

            <div class="course-detail-video-footer">
              <div class="course-detail-video-footer-section">
                <phone-watch
                  class="course-detail-video-footer-item btn"
                  :url="data.wechat_link"
                  @reportShow="reportShow({ show: 'popup_phone' })"
                ></phone-watch>
                <practice-doc
                  class="course-detail-video-footer-item btn"
                  :data="data.more.exercise[0]"
                  @click.native="reportClick({ click: 'courseware' })"
                ></practice-doc>
                <comment
                  :id="id"
                  :series="data.subject_id"
                  class="course-detail-video-footer-item btn"
                  :reportClick="(params) => this.reportUsefulTipClick(params)"
                  :reportShow="(params) => this.reportUsefulTipShow(params)"
                ></comment>
              </div>
              <div class="course-detail-video-footer-section">
                <share
                  class="course-detail-video-footer-item btn"
                  :shareUrl="data.wechat_link"
                  @click.native="reportClick({ click: 'wechatshare' })"
                ></share>
                <fav-btn
                  class="course-detail-video-footer-item btn"
                  :id="id"
                  :isFav="isFav"
                  @change="handleFav"
                  @click.native="reportClick({ click: 'collect' })"
                >
                  <icon
                    :type="`iconic_collect${
                      isFav && this.$store.state.user.userInfo ? '_sel' : ''
                    }`"
                  ></icon>
                  {{ data.post_favorites | crowd }}
                </fav-btn>
                <like-btn
                  class="course-detail-video-footer-item btn"
                  :id="id"
                  :isLike="isLike"
                  @change="handleLike"
                  @click.native="reportClick({ click: 'praise' })"
                >
                  <icon
                    :type="`iconic_like${
                      isLike && this.$store.state.user.userInfo ? '_sel' : ''
                    }`"
                  ></icon>
                  {{ data.post_like | crowd }}
                </like-btn>
                <span class="course-detail-video-footer-item"><icon type="played"></icon>{{ data.post_hits | crowd }}</span>
              </div>
            </div>
          </div>

          <!-- 展示受localStorage影响，只在前端展示 -->
          <client-only>
            <video-banner
              class="course-detail-banner"
              v-if="
                opData.bottom_banner &&
                opData.bottom_banner.data &&
                isShowVideoBottomBanner &&
                !opData.bottom_banner.hide
              "
              :url="opData.bottom_banner.data.link"
              :image="opData.bottom_banner.data.image"
              @click.native="handleBottomBannerClick"
              @close="handleBottomBannerClose"
            ></video-banner>
          </client-only>
          <div
            class="course-detail-download"
            v-if="!this.isMobile"
          >
            <template v-if="isFromGovTip">
              <span
                >本教程适用版本：WPS Office 2019 专业版/增强版/专业增强版</span
              >
            </template>

            <template v-else>
              本教程适用版本：{{ data.more.download_wps_text }}
              <lr-link
                :to="downloadWpsUrl"
                target="_blank"
                @click="
                  reportClick({
                    click: 'download',
                  })
                "
                >点此下载</lr-link
              >
            </template>
          </div>

          <div class="course-detail-description">
            <page-tab
              class="course-detail-description-tab"
              itemWidth="114"
              :list="tabList"
              :current="tab"
              @item-click="handleTabChange"
            ></page-tab>

            <article
              class="course-detail-description-content"
              v-show="tab === 'content'"
              v-html="data.post_content"
            ></article>

            <article
              class="course-detail-description-content"
              v-show="tab === 'case'"
              v-html="data.post_case"
            ></article>

          </div>
        </div>

        <aside class="course-detail-sidebar">
          <series-box
            class="course-detail-sidebar-item"
            :title="data.subject_desc"
            :data="subjects"
            :currentId="id"
            :sid="data.subject_id"
            :readPostIdMap="readPostIdMap"
            :isSubscribe="isSubscribe"
            :isJoinUserLearning="isJoinUserLearning"
            :handleJoinUserLearningSuccess="handleJoinUserLearningSuccess"
            :handleCancelUserLearningSuccess="this.handleCancelUserLearningSuccess"
            :handleChangeIsAllowPush="handleChangeIsAllowPush"
            :handleChangeIsAllowGlobalPush="handleChangeIsAllowGlobalPush"
            :isAllowUserLearningPush="isAllowUserLearningPush"
            :isAllowUserLearningGlobalPush="isAllowUserLearningGlobalPush"
            :reportClick="(params) => this.reportClick(params)"
            :reportShow="(params) => this.reportShow(params)"
            :seriesProgressShow="seriesProgressShow"
            @subscribe-change="handleSubscribeChange"
            @content-click="
              (item) =>
                this.reportClick({
                  click: 'content',
                  listid: item.id,
                  area: 'rightlist',
                })
            "
            v-if="isSubject"
          ></series-box>
          <course-box
            class="course-detail-sidebar-item"
            title="看了此视频的人还看了这些"
            v-if="opData.relateds && opData.relateds.length"
            :data="opData.relateds"
            @content-click="
              (item) =>
                this.reportClick({
                  click: 'content',
                  listid: item.id,
                  area: 'righthot',
                })
            "
          ></course-box>
          <course-box
            class="course-detail-sidebar-item"
            title="推荐学习课程"
            v-if="opData.recommends && opData.recommends.length"
            :data="opData.recommends"
            isSeries
            @content-click="
              (item) =>
                this.reportClick({
                  click: 'content',
                  listid: item.id,
                  area: 'course',
                })
            "
          ></course-box>
          <!-- 展示受localStorage影响，只在前端展示 -->
          <client-only>
            <video-banner
              class="course-detail-sidebar-item"
              v-if="
                opData.right_banner &&
                opData.right_banner.data &&
                isShowVideoRightBanner &&
                !opData.right_banner.hide
              "
              :url="opData.right_banner.data.link"
              :image="opData.right_banner.data.image"
              @click.native="handleRightBannerClick"
              @close="handleRightBannerClose"
            ></video-banner>
          </client-only>
        </aside>
      </div>

      <feedback-help
        ref="feedback-help"
        :id="id"
        :from-channel="3"
        area="bottom_right"
        sort="video"
        :series="data.subject_id"
        @useful-click="handleUsefulClick"
      >
      </feedback-help>
    </template>

    <empty v-else></empty>
  </article>
</template>

<script>
import PageTab from '@/components/page-tab';
import SeriesBox from './components/series-box';
import CourseBox from './components/course-box';
import PcPlayer from './components/pc-player';
import MobilePlayer from './components/mobile-player';
import VideoEnd from './components/video-end';
import VideoBanner from './components/video-banner';
import FeedbackHelp from '@/components/common/feedback-help';

import PhoneWatch from './components/footer-btn/phone-watch';
import PracticeDoc from './components/footer-btn/pratice-doc';
import Share from './components/footer-btn/share';
import Comment from './components/footer-btn/comment';
import FavBtn from '@/components/common-btns/fav-btn';
import LikeBtn from '@/components/common-btns/like-btn';
import Empty from '@/components/page-empty';
import JoinLearningPopup from './components/join-learning-popup';
import WxQrcodePopup from './components/wx-qrcode-popup';
import GuideToPhone from './components/guide-to-phone';

import mixinAsyncData from '@/common/mixin/mixin-async-data';
import { COMPONENT_MAP, FOOTER_HEIGHT } from '@/common/constant';
import {
  debounce,
  throttling,
  isInWps,
  search2Query,
  contains,
  getCourseBackgroundTitle,
  getCourseBackgroundType,
  getCourseBackgroundUrl,
} from '@/common/utils';
import learngingReport from '@/common/utils/learning-report';

import { default as localStorage, sessionStore } from '@/common/utils/storage';
import {
  VIDEO_AUTO_PALY_KEY,
  VIDEO_BOTTOM_BANNER_KEY,
  VIDEO_RIGHT_BANNER_KEY,
} from '@/common/constant/storage-key';

// storage
import CoursePopupStorage from '@/common/utils/storages/course-popup';
import CourseProgressStorage from '@/common/utils/storages/course-progress';
import CourseAccessReportStorage from '@/common/utils/storages/course-access-report';

const difficultyMap = {
  0: '初级',
  1: '中级',
  2: '高级',
};

async function asyncData({ params, app, route, query }) {
  const id = params.id ? +params.id : '';
  const sid = query.sid ? +query.sid : '';
  const { path } = route;
  const isPreview = path.includes('preview');

  const isFromGovTip = query.chan === 'pc_win_govtips'; // 是否来自政企版pc客户端提示

  const [detailRes, advanceRes, opRes] = await Promise.all([
    app.$service.learning.getCourseDetail(id, sid, isPreview),
    app.$service.learning.getAdvanceCourses(),
    app.$service.learning.getCourseOpData(id),
  ]).catch(() => (null, null, null));

  const data = detailRes?.data || {};
  const course = data?.course;
  const advanceData = advanceRes?.data?.jpk || {};
  const opData = opRes?.data || {};

  let breadcrumbData;
  let isSubject;
  let isMobile;
  if (course) {
    isSubject = !!course.subject_id;
    isMobile = course.post_type === 11;

    // 获取面包屑
    if (!isMobile) {
      const breadcrumbRes = await app.$service.learning.getBreadcrumb(
        course.post_type,
        id,
        course.subject_id
      );

      breadcrumbData = (breadcrumbRes && breadcrumbRes.data) || [];
    }
    const poster_type = getCourseBackgroundType(course);
    const poster_url = getCourseBackgroundUrl(poster_type);
    const poster_title = getCourseBackgroundTitle(course);
    course._poster_url = poster_url;
    course._poster_title = poster_title;
  }

  return {
    data: course,
    subjects: data?.subjects,
    id,
    advanceData,
    breadcrumbData,
    opData,
    isMobile,
    isSubject,
    isFromGovTip,
  };
}

// tab的上报映射表
const tabReportMap = {
  content: 'analysis',
  case: 'case',
  recommend: 'edu',
};

export default {
  head() {
    let header = this.$head.defaultHead();

    const { data } = this;
    const siteInfo = this.$store.state.common.siteInfo;

    const title = `${(data && data.post_title) || ''}-WPS学堂`;
    const keywords = `${data && data.post_keywords},${
      siteInfo?.site_seo_keywords
    }`;
    const description = `${data && data.post_excerpt},${
      siteInfo?.site_seo_description
    }`;

    let options = {
      title,
      keywords,
      description,
    };

    if (data) {
      header = this.$head.detailHead(options);
    }

    return header;
  },

  data() {
    return {
      difficultyMap,

      tab: 'content',
      downloadWpsUrl: 'https://pc-package.wpscdn.cn/wps/download/W.P.S.20.3041.exe', // wps下载链接
      status: {
        playIconShow: true,
        pauseIconShow: false,
        playing: false,
        // 全屏状态
        fullScreen: false,
        // 有无帮助
        videoPlayingUsefulTipShow: false,
        videoEndUsefulTipShow: false,
        usefulClick: false,
        // 静音提示
        videoMutedNoticeShow: false,
        playerEnd: false,
        notplayHelperShow: true,
        // isShowVideoEnd xx
        // 进度条拖动中
        seeking: false,
      },

      isLike: 0,
      isFav: 0,
      isSubscribe: 0,

      player: null,

      data: null,
      subjects: [],
      id: '',
      advanceData: null,
      breadcrumbData: null,
      opData: null,
      isMobile: false,
      isSubject: false,

      videoBottomBannerCloseUrl: {},
      videoRightBannerCloseUrl: {},
      learngingReport: {},

      leftKey: { time: Date.now(), count: 0 },
      rightKey: { time: Date.now(), count: 0 },

      articleProgress: 0,
      videoProgress: 0,
      videoClickTimestamp: 0,
      keyboardTimestamp: 0,
      videoWrapper: {
        width: 924,
        height: 520,
      },

      popupShow: false,

      // 是否已经加入我的学习
      isJoinUserLearning: false,

      // 是否开启我的学习推送
      isAllowUserLearningPush: false,
      // 是否全局开启我的学习推送
      isAllowUserLearningGlobalPush: false,

      //是否学完
      isFinishRead: false,

      //加入我的学习弹窗
      joinLearningPopupShow: false,
      //学堂公众号二维码弹窗
      wxQRCodePopupShow: false,
      // 系列课进度
      readPostIdMap: {},
      // 系列课进度
      seriesProgressShow: false,
      // 暂停时引导弹窗展示
      pauseGuidePopupShow: false,
    };
  },

  mixins: [mixinAsyncData(asyncData)],

  components: {
    PageTab,
    SeriesBox,
    CourseBox,
    PcPlayer,
    MobilePlayer,
    VideoEnd,
    VideoBanner,
    Empty,

    PhoneWatch,
    PracticeDoc,
    Share,
    Comment,

    FavBtn,
    LikeBtn,

    FeedbackHelp,
    JoinLearningPopup,
    WxQrcodePopup,
    GuideToPhone
  },

  watch: {
    'status.playing': function (val) {
      // 记录自动播放状态
      this.isAlreadyPlay = true;
      if (val) {
        this.status.playIconShow = false;
        this.status.pauseIconShow = true;

        // 延迟隐藏暂停按钮
        if (this.pauseClearTimer) clearTimeout(this.pauseClearTimer);
        this.pauseClearTimer = setTimeout(() => {
          if (this.status.pauseIconShow) {
            this.status.pauseIconShow = false;
          }

          clearTimeout(this.pauseClearTimer);
          this.pauseClearTimer = null;
        }, 350);
      } else {
        this.status.playIconShow = true;
        this.status.pauseIconShow = false;
      }
    },
    '$store.state.user.userInfo': async function() {
      const userId = this.$store.state.user.userInfo?.userid || null;
      this.seriesProgressShow = false;
      if (userId) {
        const readPostIdMap = {};
        const localProgress = CourseProgressStorage.getProgress(userId);
        for(const key in localProgress) {
          readPostIdMap[key] = localProgress[key];
        }
        const res = await this.$service.learning
          .getCourseProgress(this.data.subject_id)
          .catch(() => null);
        if (res?.code === 200 && res.data) {
          const readPostIds = res.data.readPostIds;
          this.seriesProgressShow = true;
          readPostIds.forEach((id) => {
            readPostIdMap[id] = '已学完';
          });
          this.readPostIdMap = readPostIdMap;
        }
        // 上报最近一次访问的时间
        if (CourseAccessReportStorage.canReport(userId)) {
          this.$service.learning.reportLastReadTime();
        }

        // 获取加入学习状态
        this.getUserLearningStatus();
      } else {
        this.seriesProgressShow = false;
        this.isJoinUserLearning= false;
      }
    }

  },

  computed: {
    // 展示的tab列表
    tabList() {
      const { data } = this;

      const contentTab = data.post_content && {
        name: '图文技巧',
        value: 'content',
      };
      const caseTab = data.post_case && {
        name: '案例',
        value: 'case',
      };

      let list = [];
      if (data.more && data.more.privilege_show === 'anli') {
        list = [caseTab, contentTab];
      } else {
        list = [contentTab, caseTab];
      }

      return list.filter((item) => !!item);
    },

    allSubjects() {
      let res = [];
      if (!this.subjects) return res;
      this.subjects.forEach((item) => {
        res = [...res, ...item.list];
      });
      return res;
    },

    // 下一节课的url
    nextCourseUrl() {
      let id;
      const { relateds, recommends } = this.opData || {};
      // 有系列课的情况下，取系列课下一节
      if (this.allSubjects.length) {
        const idx = this.allSubjects.findIndex((item) => item.id === this.id);
        const nextCourse = this.allSubjects[idx + 1];
        id = nextCourse ? nextCourse.id : this.allSubjects[0].id;
      }
      // 没有系列课则拿相关|推荐课中的第一节
      else if (
        (relateds && relateds.length) ||
        (recommends && recommends.length)
      ) {
        const nextCourse =
          (relateds && relateds[0]) || (recommends && recommends[0]);
        id = nextCourse ? nextCourse.id : null;
      }

      let url = `/learning/course/detail/id/${id}`;
      if (this.$route.query.sid) {
        url = `${url}?sid=${this.$route.query.sid}`;
      }
      return id ? url : '';
    },

    // 上报的来源
    reportSource({ isMobile }) {
      if (isMobile) return 'phone';

      return 'personal';
    },

    // 上报的所属组件
    reportComponent({ data }) {
      return COMPONENT_MAP[data && data.top_cate] || 'other';
    },

    //展示视频下方广告
    isShowVideoBottomBanner({ opData }) {
      const bannerUrl = opData?.bottom_banner?.data?.image || '';
      this.videoBottomBannerCloseUrl =
        localStorage.get(VIDEO_BOTTOM_BANNER_KEY) || {};

      //判断banner是否存在缓存中且没有过期则不展示
      if (!bannerUrl) {
        return false;
      } else {
        if (this.videoBottomBannerCloseUrl[bannerUrl]) {
          let expireTime = parseInt(this.videoBottomBannerCloseUrl[bannerUrl]);
          let nowTime = Date.now();
          if (nowTime < expireTime) {
            return false;
          }
        }
      }

      //接口存在视频的url且符合端内外限制则展示
      if (this.data?.post_video?.url) {
        let env = isInWps() ? 'app' : 'web';
        return !!opData?.bottom_banner?.data?.scene?.includes(env);
      } else {
        return false;
      }
    },

    // 展示视频右侧广告
    isShowVideoRightBanner({ opData }) {
      const bannerUrl = opData?.right_banner?.data?.image || '';
      this.videoRightBannerCloseUrl =
        localStorage.get(VIDEO_RIGHT_BANNER_KEY) || {};

      //判断banner是否存在缓存中且没有过期则不展示
      if (!bannerUrl) {
        return false;
      } else {
        if (this.videoRightBannerCloseUrl[bannerUrl]) {
          let expireTime = parseInt(this.videoRightBannerCloseUrl[bannerUrl]);
          let nowTime = Date.now();
          if (nowTime < expireTime) {
            return false;
          }
        }
      }

      //符合端内外限制则展示
      let env = isInWps() ? 'app' : 'web';
      return !!opData?.right_banner?.data?.scene?.includes(env);
    },

    detailUsefulTipShow() {
      return this.$refs['feedback-help'].status.isShowFeedbackHelp;
    },

    isCanPlayNextCourse() {
      return (
        this.allSubjects.length > 0 &&
        this.id !== this.allSubjects[this.allSubjects.length - 1].id
      );
    },

    isWithoutChannel() {
      // 当前url链接不带渠道号
      return window && window.location.search.indexOf('chan') === -1;
    },
  },

  methods: {
    handleTabChange(tab) {
      this.reportClick({ click: tabReportMap[tab] });

      this.tab = tab;
    },

    /**
     * 处理点击播放
     */
    handlePlayClick() {
      this.player.play();
    },

    /**
     * 处理点击暂停
     */
    handlePauseClick() {
      this.player.pause();
    },

    /**
     * 视频准备就绪
     * 在此处监听所有事件
     */
    handleVideoReady(player) {
      this.player = player;
      // 视频事件监听
      player.on('play', () => this.handleVideoPlay());
      player.on('pause', () => this.handleVideoPause());
      player.on('ended', () => this.handleVideoEnded());
      player.on('ratechange', () => this.handleRateChange());
      player.on(
        'timeupdate',
        throttling(
          () => {
            this.handleTimeUpdate();
          },
          500,
          1000
        )
      );

      player.on('seeking', () => {
        this.status.seeking = true;
      });
      player.on('seeked', () => {
        this.status.seeking = false;
      });

      // 全屏事件处理
      player.on('fullscreenchange', () => this.handleFullScreenChange());
      // 未加载视频调整进度资源添加toast提示
      player.on('timeupdate', this.handleVideoUnload);

      // 静音按钮点击埋点上报
      player?.controlBar?.volumePanel?.muteToggle?.on('click', () => {
        if (player.muted()) {
          this.reportClick({ click: 'mute' });
        }
        this.status.videoMutedNoticeShow = false;
      });

      // 系列课视频 - 自动播放逻辑处理
      let { play, t: time = 0 } = search2Query(location.search);
      try {
        let nextCourse = sessionStore.get(VIDEO_AUTO_PALY_KEY);
        if (
          location.pathname === nextCourse?.url?.split('?')[0] &&
          nextCourse?.time === +time
        ) {
          sessionStore.remove(VIDEO_AUTO_PALY_KEY);
          // 设置音量
          this.player.volume(nextCourse.volume);
          // 设置播放速率
          this.player.playbackRate(nextCourse.rate);
          // 自动播放
          this.handleVideoAutoPlay(nextCourse.muted);
          this.hideControlBar(3000);
        }
      } catch (e) {
        if (play) {
          this.$toast('音量设置读取失败，已开启自动静音', '', 2000);
          // 静音自动播放
          this.handleVideoAutoPlay(true);
          this.hideControlBar(3000);
        }
        console.log('session storage error', e);
      }

      // 视频交互需求已屏蔽video.js原有active交互逻辑(故需兼容移动设备访问PC端站点资源的手势交互逻辑)
      // 此处将touchstart事件挂载到video.js的tech_组件实现交互逻辑
      player?.tech_?.on('touchstart', () => {
        if (this.status.playing) {
          this.status.playing = false;
          this.player.pause();
        } else {
          this.status.playing = true;
          this.player.play();
        }
        this.showControlBar();
        this.hideControlBar(3000);
      });
      player?.controlBar?.on('touchmove', () => {
        this.showControlBar();
        this.hideControlBar(3000);
      });
    },

    /**
     * 处理视频全屏
     */
    handleFullScreenChange() {
      this.status.fullScreen = this.player.isFullscreen();
      let videoEl = document.querySelector('.video-js');
      let PCPlayer = this.$refs['PCPlayer'];
      let videoPosterTitleInstance = PCPlayer.$refs['videoPosterTitle'];

      if (this.status.fullScreen) {
        if (!this.isMobile) {
          if (videoEl && PCPlayer) {
            this.$nextTick(() => {
              // 挂载结束页dom实例到video.js
              let videoEndInstance = this.$refs['videoEnd'];
              if (videoEndInstance) {
                videoEl.appendChild(videoEndInstance.$el);
              }

              // 挂载反馈浮框dom实例到video.js
              let videoFeedbackInstance = PCPlayer.$refs['videoFeedback'];
              if (videoFeedbackInstance) {
                videoEl.appendChild(videoFeedbackInstance.$el);
              }

              // 挂载播放按钮dom实例到video.js
              let videoPlayButtonInstance = PCPlayer.$refs['videoPlayButton'];
              if (videoPlayButtonInstance) {
                videoEl.appendChild(videoPlayButtonInstance.$el);
              }

              // 挂载暂停按钮dom实例到video.js
              let videoPauseButtonInstance = PCPlayer.$refs['videoPauseButton'];
              if (videoPauseButtonInstance) {
                videoEl.appendChild(videoPauseButtonInstance.$el);
              }

              // 挂载静音提示dom实例到video.js
              let videoMutedInstance = PCPlayer.$refs['videoMuted'];
              if (videoMutedInstance) {
                videoEl.appendChild(videoMutedInstance.$el);
              }

              // 挂载poster title dom到video.js，
              if (videoPosterTitleInstance) {
                videoEl.appendChild(videoPosterTitleInstance);
              }

              // 挂载引导移动观看+关注公众号弹窗dom到video.js
              let guideToPhoneInstance = this.$refs['guideToPhone'];
              if (guideToPhoneInstance) {
                videoEl.appendChild(guideToPhoneInstance.$el);
              }
            });
          }
        }
      } else {
        // 视频封面的文字在不全屏后还原样式
        if (videoPosterTitleInstance) {
          videoPosterTitleInstance.style['font-size'] = `70px`;
          videoPosterTitleInstance.style['line-height'] = `104px`;
          videoPosterTitleInstance.style['width'] = `717px`;
        }
      }

      // 全屏按钮点击上报
      this.reportClick({ click: 'full' });
    },

    // 监听视频全屏后标题缩放比例
    handleScreenResize() {
      const isFullScreen = this.player?.isFullscreen();
      if (isFullScreen) {
        if (!this.isMobile) {
          let PCPlayer = this.$refs['PCPlayer'];
          let videoPosterTitleInstance = PCPlayer.$refs['videoPosterTitle'];
          if (videoPosterTitleInstance) {
            const fullScreenWidth = window.screen.width;
            const fullScreenHeight = window.screen.height;
            let scale = 1; // 缩放比例
            // 屏幕高度小于屏幕宽度，宽高比16:9
            if (fullScreenHeight < fullScreenWidth) {
              const actualWidth = (fullScreenHeight * 16) / 9;
              // 如果计算出来的等比宽度还比当前屏幕尺寸大，则取当前屏幕宽度为伸缩基准
              if (actualWidth > fullScreenWidth) {
                scale = fullScreenWidth / this.videoWrapper.width;
              } else {
                scale = actualWidth / this.videoWrapper.width;
              }
            } else if (fullScreenHeight >= fullScreenWidth) {
              const actualHeight = (fullScreenWidth * 9) / 16;
              scale = actualHeight / this.videoWrapper.height;
            }

            const fontSizeMini = 70 * scale;
            const lineHeightMini = 104 * scale;
            const width = 717 * scale;
            videoPosterTitleInstance.style['font-size'] = `${fontSizeMini}px`;
            videoPosterTitleInstance.style[
              'line-height'
            ] = `${lineHeightMini}px`;
            videoPosterTitleInstance.style['width'] = `${width}px`;
          }
        }
      }
    },

    /**
     * 处理视频速率变化
     */
    handleRateChange() {
      let rate = this.player.playbackRate();
      if (rate !== 1) {
        this.reportClick({ click: `speed_${rate}` });
      }
    },

    /**
     * 处理视频播放
     */
    handleVideoPlay() {
      this.learngingReport.play();

      if (!this.isAlreadyPlay) {
        this.reportClick({ click: 'playvideo' });
        // 播放后1s隐藏进度条
        this.hideControlBar(1000);
      }
      this.status.playing = true;
      this.status.playerEnd = false;
      this.$refs.videoEnd.show = false;
      this.pauseGuidePopupShow = false;
    },

    /**
     * 处理视频暂停
     */
    handleVideoPause() {
      this.learngingReport.pause();
      this.reportClick({ click: 'suspendvideo' });
      this.status.playing = false;

      // fix: 拖拽进度条会触发pause事件，避免拖拽时显示弹窗
      // fix：触发playerEnd事件时会有其它弹窗，不做处理
      setTimeout(() => {
        if (this.status.seeking || this.status.playerEnd) return;
        this.pauseGuidePopupShow = true;
        this.reportShow({ show: 'popup_videopause' });
      });
    },

    /**
     * 处理视频未加载
     */
    handleVideoUnload() {
      if (!this.isAlreadyPlay && this.player.readyState() <= 0) {
        // 此处将toast挂载到video.js实例下 -> 用于处理全屏状态层级问题
        let toastInstance = this.$toast('播放后可调整进度', '', 2000);
        const videoEl = document.querySelector('.video-js');
        videoEl.appendChild(toastInstance.$el);
        // 重写toast实例关闭事件
        toastInstance.close = () => {
          videoEl.removeChild(toastInstance.$el);
          toastInstance.$destroy();
          toastInstance = null;
        };
      } else {
        this.player.off('timeupdate', this.handleVideoUnload);
      }
    },

    /**
     * 处理视频进度变化
     */
    handleTimeUpdate() {
      // 未播放过不做处理
      if (!this.isAlreadyPlay && this.player.readyState() <= 0) return;

      let maxTime = this.data.post_video?.time || this.player.duration() || 0;
      let currentTime = this.player.currentTime();
      this.learngingReport.progressUpdate(currentTime);

      // 移动版视频不做处理
      if (!this.isMobile) {
        let diffTime = maxTime - currentTime;
        if (diffTime > 5 && diffTime <= 15) {
          if (!this.status.usefulClick) {
            this.status.videoPlayingUsefulTipShow = true;
            this.$refs['feedback-help']?.handleClose();
          }
        } else {
          this.status.videoPlayingUsefulTipShow = false;
        }

        // 处理手动调整到结束位置 - 取0.1s作为误差
        // this.$refs['videoEnd'].show = diffTime >= -0.1 && diffTime <= 0.1;
        if (diffTime >= -0.1 && diffTime <= 0.1) {
          this.handleVideoEnded();
        }
      }

      // 上报视频播放进度
      let currentProgress = Math.round((currentTime / maxTime) * 10) / 10;
      if (currentProgress > 0 && this.videoProgress < currentProgress) {
        let process = 0;
        if (currentProgress >= 0.3 && currentProgress < 0.5) {
          process = 0.3;
        } else if (currentProgress >= 0.5 && currentProgress < 0.9) {
          process = 0.5;
        } else if (currentProgress >= 0.9 && currentProgress < 1) {
          process = 0.9;
        } else if (currentProgress >= 1) {
          process = 1;
        }

        if (this.videoProgress < process) {
          this.reportShow({ show: `video_${process}` });
          this.videoProgress = process;
        }
      }
    },

    /**
     * 处理视频结束
     */
    handleVideoEnded() {
      this.reportClick({ click: 'endvideo' });

      if (!this.isMobile) {
        this.status.playerEnd = true;

        const userId = this.$nuxt.$store.state.user?.userInfo?.userid || '';
        //学完且未加入我的学习且第一次弹窗
        if (
          this.isFinishRead &&
          !this.isJoinUserLearning &&
          CoursePopupStorage.checkAndSetIsFirstPopup(
            userId,
            this.data.subject_id,
            'joinPopup'
          )
        ) {
          const isFullScreen = this.player?.isFullscreen();
          if (isFullScreen) {
            this.player.exitFullscreen();
          }
          this.reportShow({ show: `popup_add` });
          this.joinLearningPopupShow = true;
          return;
        }
        if (this.joinLearningPopupShow || this.wxQRCodePopupShow) {
          return;
        }

        this.$refs.videoEnd.show = true;
        this.status.videoPlayingUsefulTipShow = false;
        this.status.videoEndUsefulTipShow = false;
        if (!this.status.usefulClick) {
          this.status.videoEndUsefulTipShow = true;
        }
      }
    },

    /**
     * 处理videobanner视频底部广告位点击
     */
    handleBottomBannerClick() {
      const { opData } = this;
      const bannerUrl = opData.bottom_banner.data.image;

      this.reportClick({ click: 'banner', image: opData.bottom_banner.id });

      if (
        !opData?.bottom_banner?.data?.after_click_display &&
        !opData?.bottom_banner?.hide
      ) {
        this.opData.bottom_banner = {
          ...this.opData.bottom_banner,
          hide: true,
        };

        let options = {
          bannerUrl,
          key: VIDEO_BOTTOM_BANNER_KEY,
          videoBannerCloseUrl: this.videoBottomBannerCloseUrl,
        };

        this.storeVideoBannerCloseUrl(options);
      }
    },

    /**
     * 处理videobanner视频右侧广告位点击
     */
    handleRightBannerClick() {
      const { opData } = this;
      const bannerUrl = opData.right_banner.data.image;

      this.reportClick({ click: 'banner', image: opData.right_banner.id });

      if (
        !opData?.right_banner?.data?.after_click_display &&
        !opData?.right_banner?.hide
      ) {
        this.opData.right_banner = {
          ...this.opData.right_banner,
          hide: true,
        };

        let options = {
          bannerUrl,
          key: VIDEO_RIGHT_BANNER_KEY,
          videoBannerCloseUrl: this.videoRightBannerCloseUrl,
        };

        this.storeVideoBannerCloseUrl(options);
      }
    },

    /**
     * 处理VideoBanenrUrl写入缓存
     */
    storeVideoBannerCloseUrl({ bannerUrl, key, videoBannerCloseUrl }) {
      const expireTime = Date.now() + 30 * 24 * 60 * 60 * 1000;

      localStorage.set(key, {
        ...videoBannerCloseUrl,
        [bannerUrl]: expireTime,
      });
    },

    /**
     * 处理收藏
     */
    handleFav(status) {
      this.isFav = status;

      if (status) {
        this.data.post_favorites = +this.data.post_favorites + 1;
      } else {
        this.data.post_favorites = +this.data.post_favorites - 1;

        //避免因为页面缓存出现-1的状况
        if (this.data.post_favorites < 0) {
          this.data.post_favorites = 0;
        }
      }
    },

    /**
     * 处理点赞
     */
    handleLike(status) {
      this.isLike = status;
      if (status) {
        this.data.post_like = +this.data.post_like + 1;
      } else {
        this.data.post_like = +this.data.post_like - 1;
      }

      //避免因为页面缓存出现-1的状况
      if (this.data.post_like < 0) {
        this.data.post_like = 0;
      }
    },

    /**
     * 监听订阅状态变化
     */
    handleSubscribeChange(status) {
      this.isSubscribe = status;
    },

    /**
     * 处理底部banner关闭
     */
    handleBottomBannerClose() {
      const { opData } = this;
      const bannerUrl = opData.bottom_banner.data.image;

      this.reportClick({
        click: 'bannerclose',
        image: opData.bottom_banner.id,
      });

      this.opData.bottom_banner = {
        ...this.opData.bottom_banner,
        hide: true,
      };

      let options = {
        bannerUrl,
        key: VIDEO_BOTTOM_BANNER_KEY,
        videoBannerCloseUrl: this.videoBottomBannerCloseUrl,
      };

      this.storeVideoBannerCloseUrl(options);
    },

    /**
     * 处理右部banner关闭
     */
    handleRightBannerClose() {
      const { opData } = this;
      const bannerUrl = opData.right_banner.data.image;

      this.reportClick({ click: 'bannerclose', image: opData.right_banner.id });

      this.opData.right_banner = {
        ...this.opData.right_banner,
        hide: true,
      };

      let options = {
        bannerUrl,
        key: VIDEO_RIGHT_BANNER_KEY,
        videoBannerCloseUrl: this.videoRightBannerCloseUrl,
      };

      this.storeVideoBannerCloseUrl(options);
    },

    /**
     * 处理视频点击交互
     */
    handleVideoClick() {
      // 记录当前视频点击时间戳用于自动播放过程区分用户主动暂停与浏览器强制暂停行为
      this.videoClickTimestamp = Date.now();
    },

    /**
     * 处理视频自动播放
     * @param {Boolean} muted 是否静音播放
     */
    handleVideoAutoPlay(muted = false) {
      if (!this.isAlreadyPlay) {
        // 处理自动播放兼容 -> firefox、safari无法有声播放拦截兼容
        const autoPlay = () => {
          // 强制静音
          this.player.muted(true);
          // fix: firefox need play on every loadstart
          this.player.autoplay('muted');
          // fix: safari need paly by origin video play
          this.player.autoplay(true);
        };

        autoPlay();

        // 自动播放后 - 监听一次播放事件用于恢复声音处理
        this.player.one('play', () => {
          // 尝试恢复声音
          this.player.muted(muted);

          // 监听一次视频pause事件 - 用于浏览器强制暂停行为的降级方案静音播放处理
          let timestamp = Date.now();
          this.player.one('pause', () => {
            let now = Date.now();
            let isUserClicKVideoArea =
              this.videoClickTimestamp >= timestamp &&
              this.videoClickTimestamp <= now;
            let isUserPressKeyboard =
              this.keyboardTimestamp >= timestamp &&
              this.keyboardTimestamp <= now;
            // 2s内触发pause && 用户未点击视频区域 && 用户未按下键盘
            if (
              now - timestamp < 2000 &&
              !isUserClicKVideoArea &&
              !isUserPressKeyboard
            ) {
              autoPlay();
              this.status.videoMutedNoticeShow = true;
            }
          });
        });
      } else {
        this.player.play();
        this.player.muted(muted);
      }
    },

    /**
     * 处理有无帮助事件
     */
    handleUsefulClick() {
      this.status.usefulClick = true;
    },

    /**
     * 显示视频控制区
     */
    showControlBar() {
      if (!this.player) return;
      this.status.notplayHelperShow = true;
      this.player.controlBar.show();
    },

    /**
     * 隐藏视频控制区
     */
    hideControlBar(duration = 0) {
      if (!this.player) return;

      if (this.hideControlBarTimer) {
        clearTimeout(this.hideControlBarTimer);
        this.hideControlBarTimer = null;
      }

      this.hideControlBarTimer = setTimeout(() => {
        this.player.controlBar.hide();
        this.status.notplayHelperShow = false;

        clearTimeout(this.hideControlBarTimer);
        this.hideControlBarTimer = null;
      }, duration);
    },

    /**
     * 处理视频区域移动
     */
    handleVideoMouseMove() {
      this.showControlBar();
      this.hideControlBar(3000);
    },

    /**
     * 处理视频区域移入
     * @param {*} e 触发事件
     * @param {*} source 事件绑定元素(由于此处是异步执行事件且event.currentTarget在事件执行完会自动销毁，故需手动传递)
     */
    handleVideoMouseEnter(e, source) {
      if (!source) return;
      // 事件触发元素
      let target = e.target;
      // 关联元素
      let related = e.relatedTarget;
      // FIX: 内部元素隐藏显示会导致触发父元素的mouseenter事件
      // 事件触发元素为事件绑定元素 || 事件绑定元素与关联元素非包含关系
      if (source === target || !contains(source, related)) {
        this.showControlBar();
        this.hideControlBar(3000);
      }
    },

    /**
     * 处理视频区域移出
     * @param {*} e 触发事件
     * @param {*} source 事件绑定元素(由于此处是异步执行事件且event.currentTarget在事件执行完会自动销毁，故需手动传递)
     */
    handleVideoMouseOut(e, source) {
      if (!source) return;
      // 事件触发元素
      let target = e.target;
      // 关联元素
      let related = e.relatedTarget;
      // FIX: 内部元素隐藏显示会导致触发父元素的mouseout事件
      // 事件触发元素为事件绑定元素 || 事件绑定元素与关联元素非包含关系
      if (source === target || !contains(source, related)) {
        this.hideControlBar(200);
      }
    },

    /**
     * 处理视频播放 - 键盘
     */
    handleVideoPlayByKeyboard() {
      if (this.status.playing) {
        this.status.playing = false;
        this.player.pause();
        this.reportClick({ click: 'keyboard_play' });
      } else {
        this.status.playing = true;
        this.handleVideoAutoPlay();
        if (!this.isAlreadyPlay) {
          this.hideControlBar(1000);
          this.reportClick({ click: 'playvideo' });
        }
        this.reportClick({ click: 'keyboard_play' });
      }
    },

    /**
     * 处理视频快进 - 键盘
     */
    handleVideoFastForwardByKeyboard(isLongPress) {
      // 最大连按次数
      const MAX_PRESS_COUNT = 4;
      // 单按或1s内连续按
      const isInOneSecond = Date.now() - this.rightKey.time < 1000;

      // 上报交互操作
      this.reportClick({ click: 'keyboard_fast' });

      // 长按视频加载检测 && readyState => 3(当前播放位置的数据可用)
      if (isLongPress && this.player.readyState() < 3) return;

      // 连按视频资源加载检测 && readyState => 3(当前播放位置的数据可用)
      if (
        this.rightKey.count >= MAX_PRESS_COUNT &&
        this.player.readyState() < 3
      )
        return;

      // 展示结束页面屏蔽快进
      if (this.$refs.videoEnd.show) return;

      const increaseVideoTime = (time, seed) => {
        const maxTime =
          this.data.post_video?.time || this.player.duration() || 0;
        if (time >= maxTime) return;

        time = time + seed < maxTime ? time + seed : maxTime;
        this.player.currentTime(time);

        // 进度条显示
        this.showControlBar();
        if (this.player.readyState() < 3) {
          this.player.on('playing', () => {
            this.hideControlBar(2000);
            this.player.off('playing');
          });
        }
      };

      // 长按处理 -> 间隔超过1s
      if (isLongPress) {
        if (Date.now() - this.rightKey.time >= 1000) {
          increaseVideoTime(this.player.currentTime(), 60);
          this.leftKey.time = Date.now();
          this.rightKey.count = 0;
        }

        return;
      }

      if (!isInOneSecond) {
        this.rightKey.time = Date.now();
        this.rightKey.count = 0;
      }

      if (
        !isInOneSecond ||
        (isInOneSecond && this.rightKey.count < MAX_PRESS_COUNT)
      ) {
        const maxTime =
          this.data.post_video?.time || this.player.duration() || 0;
        let currentTime = this.player.currentTime();

        // 自动播放
        if (!this.status.playing && currentTime < maxTime) {
          this.status.playing = true;
          this.handleVideoAutoPlay();
        }

        increaseVideoTime(currentTime, 10);
        this.rightKey.count++;
      }
    },

    /**
     * 处理视频快退 - 键盘
     */
    handleVideoFastBackwardByKeyboard(isLongPress) {
      // 最大连按次数
      const MAX_PRESS_COUNT = 4;
      // 单按或1s内连续按
      const isInOneSecond = Date.now() - this.leftKey.time < 1000;

      // 上报交互操作
      this.reportClick({ click: 'keyboard_rewind' });

      // 长按视频加载检测 && readyState => 3(当前播放位置的数据可用)
      if (isLongPress && this.player.readyState() < 3) return;

      // 连按视频资源加载检测 && readyState => 3(当前播放位置的数据可用)
      if (this.leftKey.count >= MAX_PRESS_COUNT && this.player.readyState() < 3)
        return;

      const reduceVideoTime = (time, seed) => {
        // 当视频已结束 - 更新进度条到最大值
        if (this.$refs.videoEnd.show) {
          time = this.data.post_video?.time || this.player.duration() || 0;
        }

        if (time <= 0) return;

        time = time - seed > 0 ? time - seed : 0;
        this.player.currentTime(time);

        // 进度条显示
        this.showControlBar();
        if (this.player.readyState() < 3) {
          this.player.on('playing', () => {
            this.hideControlBar(2000);
            this.player.off('playing');
          });
        }
      };

      // 长按处理 -> 间隔超过1s
      if (isLongPress) {
        if (Date.now() - this.leftKey.time >= 1000) {
          reduceVideoTime(this.player.currentTime(), 60);
          this.leftKey.time = Date.now();
          this.leftKey.count = 0;
        }

        return;
      }

      if (!isInOneSecond) {
        this.leftKey.time = Date.now();
        this.leftKey.count = 0;
      }

      if (
        !isInOneSecond ||
        (isInOneSecond && this.leftKey.count < MAX_PRESS_COUNT)
      ) {
        let currentTime = this.player.currentTime();

        // 自动播放
        if (!this.status.playing && currentTime > 0) {
          this.status.playing = true;
          this.handleVideoAutoPlay();
        }

        reduceVideoTime(currentTime, 10);
        this.leftKey.count++;
      }
    },

    /**
     * 处理键盘控制视频播放
     */
    handleKeyboardDown(e) {
      // 记录用户键盘按下时间戳
      this.keyboardTimestamp = Date.now();

      // 长按事件校验
      let isLongPress = this.lastKeyCode === e.keyCode;

      switch (e.keyCode) {
        // 空格键
        case 32:
          this.debounceVideoPlayByKeyboard();
          e.preventDefault();
          break;

        // 左方向键
        case 37:
          this.handleVideoFastBackwardByKeyboard(isLongPress);
          e.preventDefault();
          break;

        // 右方向键
        case 39:
          this.handleVideoFastForwardByKeyboard(isLongPress);
          e.preventDefault();
          break;

        default:
          '';
      }

      // 记录key-down键码
      this.lastKeyCode = e.keyCode;
    },

    handleKeyboardUp() {
      // 重置key-down键码
      this.lastKeyCode = '';
    },

    /**
     * 获取点赞、收藏、订阅状态
     */
    async getUserState() {
      const [likeFavRes, subRes] = await Promise.all([
        this.$service.learning.getLikeFavState(this.id),
        this.data.subject_id
          ? this.$service.learning.getSubState(this.data?.subject_id, this.id)
          : null,
      ]).catch(() => [null, null]);

      if (likeFavRes && likeFavRes.data) {
        this.isLike = likeFavRes.data.is_like;
        this.isFav = likeFavRes.data.is_fav;
      }

      if (subRes && subRes.data) {
        this.isSubscribe = subRes.data.is_sub;
      }
    },

    async getUserLearningStatus() {
      const res = await this.$service.learning.getUserLearningStatus(
        this.id,
        this.data.subject_id
      );
      if (res?.code === 200 && res.data) {
        this.isJoinUserLearning = res.data.is_join;
        this.isAllowUserLearningPush = res.data.is_allow_push;
        this.isAllowUserLearningGlobalPush = res.data.is_allow_global_push;
      }
    },

    /**
     * 上报用户评价展示
     */
    reportUsefulTipShow({ show, area, type, series }) {
      this.$collect.isHelpSubmitShow({
        show,
        sort: 'video',
        area,
        type,
        series,
      });
    },

    /**
     * 上报用户评价展示
     */
    reportUsefulTipClick({ click, area, type, series }) {
      this.$collect.isHelpSubmitClick({
        click,
        sort: 'video',
        area,
        type,
        series,
      });
    },

    /**
     * 上报点击事件的方法
     */
    reportClick({ click, area, image, listid }) {
      this.$collect.detailsSkillvideoClick({
        click,
        type: this.id,
        series: this.data?.subject_id,
        area,
        image,
        listid,
      });
    },

    /**
     * 上报展示事件的方法
     */
    reportShow({ show, image }) {
      this.$collect.detailsSkillvideoShow({
        show,
        type: this.id,
        series: this.data?.subject_id,
        image,
        component: this.reportComponent,
        add: this.data ? (this.isJoinUserLearning ? 2 : 1): 0
      });
    },

    /**
     * 上报滚动触底事件
     */
    reportScrollBottom() {
      // 首次滚动上报
      if (!this.isScrolled) {
        this.isScrolled = true;
        this.reportShow({ show: 'scroll' });
      }

      // 页面底部计算
      const { bottom } = document.body.getBoundingClientRect();
      const { innerHeight } = window;

      if (bottom - innerHeight <= FOOTER_HEIGHT) {
        this._isScrollBottom = true;
      }

      // 图文浏览进度计算
      const articleContainer = document.getElementsByClassName(
        'course-detail-description'
      )[0];
      if (articleContainer) {
        const { top, height } = articleContainer.getBoundingClientRect();
        const scrollTop = document.documentElement.scrollTop;
        const clientHeight = document.documentElement.clientHeight;

        // 上报图文阅读进度
        let currentProgress =
          Math.round(
            ((clientHeight + scrollTop - (top + scrollTop)) / height) * 100
          ) / 100;
        if (currentProgress > 0 && this.articleProgress < currentProgress) {
          let process = 0;
          if (currentProgress > 0.3 && currentProgress < 0.5) {
            process = 0.3;
          } else if (currentProgress >= 0.5 && currentProgress < 0.9) {
            process = 0.5;
          } else if (currentProgress >= 0.9 && currentProgress < 1) {
            process = 0.9;
          } else if (currentProgress >= 1) {
            process = 1;
          }

          if (this.articleProgress < process) {
            this.reportShow({ show: `article_${process}` });
            this.articleProgress = process;
          }
        }
      }
    },

    afterMounted() {
      const { data, opData } = this;

      // 记录进入时长
      this._enterTime = Date.now();

      if (data) {
        this.tab =
          data.more && data.more.privilege_show === 'anli' ? 'case' : 'content';

        this.getUserState();

        // 记录访问
        this.$service.learning.readPostItem(this.data.post_type, this.id);
      }

      // 右侧相关技巧区域展示
      if (opData.relateds && opData.relateds.length) {
        this.reportShow({ show: 'righthot' });
      }

      // 右侧推荐课程区域展示
      if (opData.recommends && opData.recommends.length) {
        this.reportShow({ show: 'course' });
      }

      // 上报窗口下方banner展示
      if (
        opData &&
        opData.bottom_banner &&
        opData.bottom_banner.data &&
        this.isShowVideoBottomBanner &&
        !opData.bottom_banner.hide
      ) {
        this.reportShow({ show: 'banner', image: opData.bottom_banner.id });
      }

      // 上报窗口右侧banner展示
      if (
        opData &&
        opData.right_banner &&
        opData.right_banner.data &&
        this.isShowVideoRightBanner &&
        !opData.right_banner.hide
      ) {
        this.reportShow({ show: 'banner', image: opData.right_banner.id });
      }

      // 上报详情页展示
      this.reportShow({ show: 'details' });

      // 监听上报滚动到底部的事件
      this.debounceReportScrollBottom = debounce(this.reportScrollBottom, 300);
      window.addEventListener('scroll', this.debounceReportScrollBottom);

      // 监听键盘操作事件 - 控制视频播放
      this.debounceVideoPlayByKeyboard = debounce(
        this.handleVideoPlayByKeyboard,
        300
      );
      window.document.addEventListener(
        'keydown',
        this.handleKeyboardDown,
        true
      );
      window.document.addEventListener('keyup', this.handleKeyboardUp, true);

      // 视频控制栏事件
      this.debounceVideoMouseEnter = debounce(this.handleVideoMouseEnter, 300);
      this.throttlingVideoMouseMove = throttling(
        this.handleVideoMouseMove,
        100,
        300
      );
      this.debounceVideoMouseOut = debounce(this.handleVideoMouseOut, 300);

      // 上报页面结束
      window.addEventListener('beforeunload', () => {
        if (this._isBeforeUnload) return;
        this._isBeforeUnload = true;
        this.$collect.detailsSkillvideoEnd({
          view: this._isScrollBottom ? 'yes' : 'no',
          time: Math.ceil((Date.now() - this._enterTime) / 1000),
          type: this.id,
        });
      });

      // 初始化已学上报
      this.learngingReport = new learngingReport({
        key: this.data?.post_video?.url,
        videoDuration: this.data?.post_video?.time,
        postType: this.data?.post_type,
        postId: this.data?.id,
        reportHook: this.finishReadHook,
      });
    },

    finishReadHook() {
      this.isFinishRead = true;
    },
    joinUserLearning() {
      this.joinLearningPopupShow = false;
      if (!this.$checkAuth()) {
        return;
      }

      this.$service.learning
        .joinUserLearning(this.id, this.data.subject_id)
        .then((res) => {
          if (res.code === 200) {
            this.$toast.success('加入我的学习成功');
            this.handleJoinUserLearningSuccess();
          } else {
            this.$toast(res.msg);
          }
        });
    },

    async handleJoinUserLearningSuccess() {
      this.isJoinUserLearning = true;
      this.isAllowUserLearningPush = true;
      this.isAllowUserLearningGlobalPush = true;
      this.joinLearningPopupShow = false;
      const userId = this.$nuxt.$store.state.user.userInfo.userid || '';
      //如果进入了video-end，则不显示弹出框
      if (this.$refs.videoEnd.show == true) {
        return;
      }
      if (
        CoursePopupStorage.checkAndSetIsFirstPopup(
          userId,
          this.data.subject_id,
          'wxPopup'
        )
      ) {
        // 判断是否已经关注公众号;
        const isSubscribe = await this.$service.vipapi.isSubscribe();
        if (isSubscribe) {
          return;
        }
        this.wxQRCodePopupShow = true;
        this.reportShow({ show: `popup_wechat` });
        this.player.pause();
      } else if (this.status.playerEnd) {
        this.handleVideoEnded();
      }
    },

    handleCancelUserLearningSuccess() {
      this.isJoinUserLearning = false;
    },
    handleChangeIsAllowPush(isAllow) {
      this.isAllowUserLearningPush = isAllow;
    },
    handleChangeIsAllowGlobalPush(isAllow) {
      this.isAllowUserLearningGlobalPush = isAllow;
    },
    handleCloseWxQRCodePopup() {
      this.wxQRCodePopupShow = false;
      if (this.status.playerEnd) {
        this.handleVideoEnded();
      } else {
        this.player.play();
      }
    },
    handleCloseJoinLearningPopup() {
      this.joinLearningPopupShow = false;
      if (this.status.playerEnd) {
        this.handleVideoEnded();
      }
    },
  },

  mounted() {
    this.throttlingHandleScreenResize = throttling(
      this.handleScreenResize,
      50,
      60
    );
    window.addEventListener('resize', this.throttlingHandleScreenResize);
  },

  destroyed() {
    window.removeEventListener('scroll', this.debounceReportScrollBottom);
    window.removeEventListener('keydown', this.handleKeyboardDown);
    window.removeEventListener('keyup', this.handleKeyboardUp);
    window.removeEventListener('resize', this.throttlingHandleScreenResize);
  },
};
</script>

<style lang="scss" scoped>
.course-detail {
  $leftWidth: 924px;

  &-title {
    position: relative;
    line-height: 33px;
    height: 33px;
  }

  &-subscribe-btn {
    @include flex-align-center();
    border-radius: 11px;
    background: #e8e8e8;
    font-size: 12px;
    font-weight: 400;
    height: 25px;
    margin-left: 18px;
    padding: 0 12px;
    cursor: pointer;

    .icon {
      font-size: 16px;
    }
  }

  &-subtitle {
    margin-top: 10px;
    font-size: 18px;
    font-weight: 700;
    line-height: 25px;

    > a {
      cursor: pointer;
      margin-left: 20px;
      font-size: 14px;
      font-weight: 500;
      color: #417ff9;
      line-height: 20px;
    }
  }

  &-info {
    color: #999;
    font-size: 12px;
    margin: 8px 0;
  }

  &-main-wrapper {
    display: flex;
  }
  &-main {
    width: $leftWidth;
    position: relative;
  }

  &-video {
    position: relative;
    min-height: 493px;

    &-wrapper {
      position: relative;
      height: 520px;
    }
    &-player {
      width: 100%;
    }

    &-footer {
      display: flex;
      justify-content: space-between;
      background: #f6f6f6;
      border: 1px solid #e8e8e8;
      padding: 0 16px;
      position: relative;
      &-section {
        @include flex-align-center();
        height: 40px;
      }

      &-item {
        display: inline-flex;
        align-items: center;

        &:not(:last-of-type) {
          margin-right: 30px;
        }

        &.btn {
          cursor: pointer;
          &.fav-btn {
            > svg {
              color: rgb(247, 201, 64);
            }
          }
        }

        .icon {
          font-size: 24px;
          margin-right: 2px;
        }
      }
    }

    &-end {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 100%;
      z-index: 1;
    }

    &-pause-popup {
      display: flex;
      position: absolute;
      top: 50%;
      left: calc(50% + 8px);
      transform: translate(-50%, -50%);
    }
  }

  &-banner {
    margin-top: 30px;
  }

  &-download {
    margin-top: 30px;

    > a {
      cursor: pointer;
      color: #417ff9;
      text-decoration: underline;
    }
  }

  &-description {
    margin-top: 30px;

    &-tab {
      margin-bottom: 30px;
    }

    &-content {
      font-size: 16px;
      line-height: 1.5;

      ::v-deep img{
        max-width: 800px !important;
      }
    }
  }

  &-sidebar {
    margin-left: 30px;
    width: 278px;

    &-item {
      margin-bottom: 20px;
    }
  }
}
</style>
